<template>
	<v-dialog
		v-model="show"
		@keydown.esc="hideDialog()"
		v-on="show ? { 'click:outside' : hideDialog } : ''"
		persistent
		scrollable
		width="672px"
	>
		<v-card flat outlined class="wall-card">
			<v-card-title class="d-flex justify-content-between align-center">
				<div>{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.header') }}</div>
				<v-btn icon @click="hideDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<group-form v-model="form" ref="group-form" />
			</v-card-text>
			<v-card-actions class="d-flex justify-end pb-5">
				<v-btn
					color="grey lighten-2"
					elevation="0"
					@click="hideDialog()"
				>{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn
					color="accent"
					elevation="0"
					@click="sendData()"
				>{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.create') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import GroupForm from "@/components/group/GroupForm";
export default {
	name: "GroupCreateDialog",
	components: {
		GroupForm
	},
	data () {
		return {
			show: false,
			form: null
		}
	},
	methods: {
		...mapActions('groups', [
			'setGroup'
		]),
		...mapActions('files', {
			avatarUpload: 'upload'
		}),
		showDialog() {
			this.show = true
		},
		hideDialog() {
			this.show = false
			this.$refs['group-form'].clearForm()
		},
		async sendData() {
			let params = Object.assign({}, this.form),
				avatarParams = (params.avatar && params.avatar.url) ? {
					type: 'image',
					for: 'group_avatar',
					file: params.avatar.url
				} : null,
				avatarResponse = (avatarParams) ? await this.avatarUpload(avatarParams) : null
			if (avatarResponse && avatarResponse.success)
				params.avatar_token = avatarResponse.token
			else
				delete params.avatar_token
			delete params.avatar
			delete params.background_token
			if (params.is_public)
				delete params.is_hide
			if (await this.setGroup({ params })) {
				this.hideDialog()
				this.$snackbar.success("Grupa została utworzona!")
			}
		}
	}
}
</script>
